import { createApp } from 'vue'
import EmailSignUpModal from './components/modals/EmailSignUpHomeowners'

const app = createApp({
  data() {
    return {
      currentStep: 1,
      currentProblem: null,
      currentProblemGroup: null,
      problems: window.culligan.problems || [],
      emailSignUpFormId: window.culligan.emailSignUpFormId || null,
    }
  },
  computed: {
    currentProblems() {
      if (! this.currentProblemGroup) {
        return []
      }

      return this.problems.filter((problem) => {
        return problem.solutionCenter.categories && problem.solutionCenter.categories.includes(this.currentProblemGroup)
      })
    }
  },
  components: {
    EmailSignUpModal
  },
  methods: {
    selectProblemGroup(group) {
      this.currentProblemGroup = group
      this.currentStep = 2
    },
    selectProblem(problem) {
      this.currentProblem = problem
      this.currentStep = 3
    },
    goBack() {
      this.currentStep -= 1
    },
    openEmailSignUpModal() {
      if (this.emailSignUpFormId) {
        this.$refs.emailSignUpModal.open()
      }
    },
    closeEmailSignUpModal() {
      this.$refs.emailSignUpModal.close()
    }
  }
})

app.mount('#solution-center')
